import React from "react";
import { Button, Tooltip, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CustomMenu from "../../../../../components/Menu";
import ArchiveMenuItems from "./ArchiveMenuItems";
import { TooltipName } from "../../../../../utils/Enums";
import { CustomButton } from "../../../../../components/Button/Button";
import { useResponsive } from "../../../../../hooks/useResponsive";

const DesktopArchiveMenu = ({
  anchorEl,
  open,
  onClose,
  onClick,
  isAdmin,
  isOwner,
  isArchive,
  onArchiveClick,
  onFeedClick,
  onWorklogsClick,
  onCSVClick,
  onMergeBoardClick,
  onManageFieldsClick,
  onSetupBoardNotificationsClick,
}) => {
  const isMobile = useResponsive("down", "md");
  return (
    <>
      <Tooltip title={TooltipName.MORE}>
        {isMobile ? (
          <MoreHorizIcon
            onClick={onClick}
            className={`${isMobile ? "mobile-board-header-more-icon" : ""}`}
          />
        ) : (
          <CustomButton
            variant="outlined"
            color="primary"
            className={`white-button archive-button`}
            onClick={onClick}
          >
            <MoreHorizIcon />
          </CustomButton>
        )}
      </Tooltip>

      <CustomMenu
        id="account-menu"
        anchorEl={anchorEl}
        className={`archive-popover ${isMobile ? "mobile-archive-board-menu" : ""}`}
        open={open}
        onClose={onClose}
        onClick={onClose}
      >
        <ArchiveMenuItems
          isAdmin={isAdmin}
          isOwner={isOwner}
          isArchive={isArchive}
          onArchiveClick={onArchiveClick}
          onFeedClick={onFeedClick}
          onWorklogsClick={onWorklogsClick}
          onCSVClick={onCSVClick}
          onMergeBoardClick={onMergeBoardClick}
          onManageFieldsClick={onManageFieldsClick}
          onSetupBoardNotificationsClick={onSetupBoardNotificationsClick}
        />
      </CustomMenu>
    </>
  );
};

export default DesktopArchiveMenu;
